import { Component } from 'utils/jsx'
import tippy from 'tippy.js'

export default class Event extends Component {
  beforeRender (props) {
    this.state = {
      title: props.moment.format('YYYY-MM-DD HH:mm') + ' — ' + props.action
    }
  }

  template (props) {
    return <div class='event' event-click={props['event-click']} />
  }

  afterRender (props) {
    const startOfDay = props.moment.clone().startOf('day').unix()
    const percentOfDay = ((props.moment.unix() - startOfDay) / (24 * 60 * 60)) * 100

    this.base.style.setProperty('--y', percentOfDay + '%')

    tippy(this.base, {
      content: this.state.title,
      placement: 'right'
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Event.js